import { createContext, FunctionComponent, ReactNode, useContext } from 'react'
import { StatsExpandedModal } from './StatsExpandedModal'
import {
  StatsAssistantChatState,
  useStatsAssistantChat,
  useStatsAssistantEnabled,
} from '../../hooks/utils/statsAssistant'

const StatsAssistantChatContext = createContext<StatsAssistantChatState | null>(null)

const StatsAssistantProviderInner: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const chat = useStatsAssistantChat()

  return (
    <StatsAssistantChatContext.Provider value={chat}>
      {children}
      <StatsExpandedModal chat={chat} />
    </StatsAssistantChatContext.Provider>
  )
}

export const StatsAssistantProvider: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  const statsAssistantEnabled = useStatsAssistantEnabled()

  if (!statsAssistantEnabled) {
    return <>{children}</>
  }

  return <StatsAssistantProviderInner>{children}</StatsAssistantProviderInner>
}

export const useStatsAssistantChatContext = (): StatsAssistantChatState | null =>
  useContext(StatsAssistantChatContext)
